import React from "react";
import { useStepperContext } from "../../context/MainContext";

const ListingType = () => {
  const { propertyData = {}, setPropertyData } = useStepperContext();

  const setType = (type) => {
    // Clear or adjust fields that depend on type
    const next = { ...propertyData, type };
    // If switching to Residential and vacant_land_type was Commercial, clear it
    if (type === "Residential" && next.vacant_land_type === "Commercial") {
      next.vacant_land_type = "";
    }
    // Reset subtype if switching away from Residential
    if (type !== "Residential") {
      next.residentialSubtype = "";
    }
    setPropertyData(next);
  };

  const setResidentialSubtype = (subtype) => {
    setPropertyData({ ...propertyData, residentialSubtype: subtype });
  };

  const setFor = (forType) =>
    setPropertyData({ ...propertyData, for: forType });

  const isSelected = (val) => propertyData["type"] === val;
  const isForSelected = (val) => propertyData["for"] === val;

  return (
    <div className="max-w-3xl mx-auto">
      <div className="text-center mb-6">
        <h2 className="text-2xl font-semibold">
          What type of property are you listing?
        </h2>
        <p className="text-sm text-slate-600 mt-2">
          Choose the primary property type. Fields shown later will adapt.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <button
          type="button"
          onClick={() => setType("Residential")}
          className={`p-6 rounded-lg border transition-all text-left shadow-sm ${
            isSelected("Residential")
              ? "ring-2 ring-blue-400 bg-blue-50"
              : "bg-white"
          }`}
        >
          <div className="flex items-center gap-4">
            <div className="text-3xl">🏠</div>
            <div>
              <div className="font-semibold">Residential</div>
              <div className="text-sm text-slate-600">
                Single-family, multi-family, condos
              </div>
            </div>
          </div>
        </button>

        <button
          type="button"
          onClick={() => setType("Commercial")}
          className={`p-6 rounded-lg border transition-all text-left shadow-sm ${
            isSelected("Commercial")
              ? "ring-2 ring-blue-400 bg-blue-50"
              : "bg-white"
          }`}
        >
          <div className="flex items-center gap-4">
            <div className="text-3xl">🏢</div>
            <div>
              <div className="font-semibold">Commercial</div>
              <div className="text-sm text-slate-600">
                Office, retail, industrial and other commercial uses
              </div>
            </div>
          </div>
        </button>
      </div>

      {/* Residential subtype dropdown */}
      {isSelected("Residential") && (
        <div className="mb-6">
          <label className="block mb-2 font-medium">Residential Type</label>
          <select
            className="w-full p-3 border rounded-lg"
            value={propertyData.residentialSubtype || ""}
            onChange={(e) => setResidentialSubtype(e.target.value)}
          >
            <option value="" disabled>
              Select type...
            </option>
            <option value="Single Family">Single Family</option>
            <option value="Apartment / Condo">Apartment / Condo</option>
            <option value="Multi-Family" disabled>
              Multi-Family (coming soon)
            </option>
            <option value="Other" disabled>
              Other (coming soon)
            </option>
          </select>
        </div>
      )}

      <div className="text-center mb-4">
        <h3 className="text-lg font-medium">Is this property for</h3>
      </div>

      <div className="flex justify-center gap-4">
        <button
          type="button"
          onClick={() => setFor("Sale")}
          className={`px-6 py-3 rounded-full border font-semibold ${
            isForSelected("Sale")
              ? "bg-green-600 text-white"
              : "bg-white text-slate-700"
          }`}
        >
          Sale
        </button>
        <button
          type="button"
          onClick={() => setFor("Lease")}
          className={`px-6 py-3 rounded-full border font-semibold ${
            isForSelected("Lease")
              ? "bg-green-600 text-white"
              : "bg-white text-slate-700"
          }`}
        >
          Lease
        </button>
      </div>
    </div>
  );
};

export default ListingType;
